import React from 'react';
import './RevenueImpact.css';

const RevenueImpact = () => {
  return (
    <section className="revenue-impact">
      <div className="revenue-impact-container">
        <h2 className="revenue-impact-title">
          You could be losing <span className="amount">$10,000+</span> per month in new patient production due to missed calls.
        </h2>
        <p className="revenue-impact-subtitle">
          The average aesthetic clinic misses 30% of their calls*. Imagine how many of those calls are new patients ready to book an appointment.
        </p>
      </div>
    </section>
  );
};

export default RevenueImpact;
